import React from 'react';
import DeliveryMap from './DeliveryMap';

interface GoogleDeliveryMapProps {
  deliveryAddress: string;
  deliveryPostcode: string;
  deliveryCity: string;
  deliveryLat?: number;
  deliveryLng?: number;
}

/**
 * GoogleDeliveryMap Component
 * 
 * Currently acts as a wrapper that always uses Leaflet's DeliveryMap component
 * for reliability and to avoid requiring a Google Maps API key.
 * 
 * Google Maps integration can be enabled in the future by:
 * 1. Adding a valid GOOGLE_MAPS_API_KEY to .env file
 * 2. Uncommenting the Google Maps implementation below
 * 3. Removing this wrapper and using Google Maps directly
 */
const GoogleDeliveryMap: React.FC<GoogleDeliveryMapProps> = ({
  deliveryAddress,
  deliveryPostcode,
  deliveryCity,
  deliveryLat,
  deliveryLng,
}) => {
  // Always use Leaflet for now - more reliable and doesn't require API key
  // Google Maps can be enabled later when API key is properly configured
  return (
    <DeliveryMap
      deliveryAddress={deliveryAddress}
      deliveryPostcode={deliveryPostcode}
      deliveryCity={deliveryCity}
      deliveryLat={deliveryLat}
      deliveryLng={deliveryLng}
    />
  );

  /* Google Maps implementation (commented out until API key is configured)
  
  To enable Google Maps:
  1. Uncomment the code below
  2. Add GOOGLE_MAPS_API_KEY to .env file
  3. Import required dependencies:
     import { GoogleMap, LoadScript, Marker, DirectionsRenderer } from '@react-google-maps/api';
     import { Box, Typography, Paper, CircularProgress } from '@mui/material';
     import { GOOGLE_MAPS_API_KEY, DEFAULT_MAP_OPTIONS } from '../config/googleMapsConfig';
     import { BRANCH_LOCATION } from '../config/branchLocation';
  
  return (
    <LoadScript 
      googleMapsApiKey={GOOGLE_MAPS_API_KEY} 
      libraries={['places', 'directions']}
      loadingElement={<CircularProgress />}
    >
      <GoogleMap
        // ... Google Maps implementation
      />
    </LoadScript>
  );
  */
};

export default GoogleDeliveryMap;

